import React from 'react';
import { Plus, Minus } from 'lucide-react';

interface CustomNumberInputProps {
  value: number;
  onChange: (val: number) => void;
  min?: number;
  max?: number;
  className?: string;
}

export const CustomNumberInput: React.FC<CustomNumberInputProps> = ({
  value,
  onChange,
  min,
  max,
  className = ''
}) => {
  const handleInc = () => {
    const next = value + 1;
    if (max !== undefined && next > max) return;
    onChange(next);
  };
  const handleDec = () => {
    const prev = value - 1;
    if (min !== undefined && prev < min) return;
    onChange(prev);
  };
  return (
    <div className={`flex items-center bg-inputBg border border-inputBorder rounded-md overflow-hidden h-[46px] w-full ${className}`}>
      <button
        type="button"
        onClick={handleDec}
        className="h-full px-2.5 hover:bg-inputHover text-inputText transition-colors shrink-0 flex items-center justify-center border-r border-inputBorder"
      >
        <Minus className="w-3.5 h-3.5" />
      </button>
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full h-full text-center text-sm bg-transparent outline-none text-inputText [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
      />
      <button
        type="button"
        onClick={handleInc}
        className="h-full px-2.5 hover:bg-inputHover text-inputText transition-colors shrink-0 flex items-center justify-center border-l border-inputBorder"
      >
        <Plus className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
